import { Button } from '@omnipresentgroup/design-system';
import { useState } from 'react';

import { UploadExpensesModal } from './UploadExpensesModal';

const UPLOAD_EXPENSES_LABEL = 'Upload';

export const UploadExpensesAction = ({
  iconOnly = false,
}: {
  iconOnly?: boolean;
}) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary"
        onClick={() => {
          setUploadModalOpen(true);
        }}
        icon="CloudUpload"
      >
        {iconOnly ? '' : UPLOAD_EXPENSES_LABEL}
      </Button>
      {uploadModalOpen && (
        <UploadExpensesModal
          modalProps={{
            open: uploadModalOpen,
          }}
          handleClose={() => {
            setUploadModalOpen(false);
          }}
        />
      )}
    </>
  );
};
